import { GrowFlex } from "@sinecycle/growcomponents";
import { FlexProps } from "./type";

function Flex(props: Readonly<FlexProps>) {
  return <GrowFlex space="8" {...props} />;
}

export { Flex };
